import { render, staticRenderFns } from "./MinuTakerView.vue?vue&type=template&id=3c0c0af4&scoped=true"
import script from "./MinuTakerView.vue?vue&type=script&lang=js"
export * from "./MinuTakerView.vue?vue&type=script&lang=js"
import style0 from "./MinuTakerView.vue?vue&type=style&index=0&id=3c0c0af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c0af4",
  null
  
)

export default component.exports